export const VIEW_TYPE = {
  MOBILE: 'mobile',
  TABLETTE: 'tablette',
  DESKTOP: 'desktop',
};

export const BREAK_POINTS = {
  MOBILE: {
    MIN: 0,
    MAX: 899,
  },
  TABLETTE: {
    MIN: 900,
    MAX: 1279,
  },
  DESKTOP: {
    MIN: 1280,
    MAX: Number.MAX_VALUE,
  },
};
